import React from 'react';
import { Stack, Box, Button } from '@mui/material';
import objetivosImg from '../../../components/assets/objetivos.png';
import formarlideres from '../../../components/assets/formarlideres.png';
import fortalecervinculos from '../../../components/assets/fortalecervinculos.png';
import { styled } from '@mui/material/styles';

const Icon = styled('img')({
  maxWidth: 40,
  maxHeight: 40,
  objectFit: 'contain',
});

const Objetivos = (props) => {

  return (
    <Stack alignItems="center" sx={{
      backgroundImage: `url(${objetivosImg})`,
      backgroundSize: 'contain',
      color: 'white',
      py: 5,
      px: '5%',
      position: 'relative',
      textShadow: '0 0 1px rgb(0 0 0 / 20%)',
    }}>
      <Box
        sx={{
          backgroundColor: 'rgb(0 0 0 / 20%)',
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
        }}
      />
      <Stack  sx={{ maxWidth: '1200px', width: '100%', zIndex: 1 }}>
        <Box sx={{ typography: 'h4', fontWeight: 'bold', mb: 2 }}>¡Regístrate antes del 8 de Marzo!</Box>
        <Stack direction={{ xs: "column", md: 'row' }} spacing={2} justifyContent>
          <Stack alignItems="center" sx={{ flex: '50%'}}>
            <Stack sx={{ fontWeight: 'bold', mb: 2 }} direction="row" spacing={1} alignItems="center">
              <span>¿Aún no te has postulado?</span>
            </Stack>
            <Button variant="contained" href="https://lem.learnala.com/apply/105" target="_blank" rel="noopener noreferrer">
              <span>Comienza tu registro aquí</span>
            </Button>
          </Stack>
          <Stack alignItems="center" sx={{ flex: '50%'}}>
            <Stack sx={{ fontWeight: 'bold', mb: 2 }} direction="row" spacing={1} alignItems="center">
              <span> ¿Ya iniciaste tu postulación?</span>
            </Stack>
            <Button variant="contained" href="https://lem.learnala.com/login" target="_blank" rel="noopener noreferrer">
              <span>Continúa con el proceso aqu</span>
            </Button>
          </Stack>
          
        </Stack>
          {/* <Stack alignItems="center" sx={{ flex: '50%'}}>
            <Stack sx={{ fontWeight: 'bold', mb: 2 }} direction="row" spacing={1} alignItems="center">
              <Icon src={formarlideres} />
              <span>Formar Líderes</span>
            </Stack>
            <span>Ofrecer experiencias formativas de alta exigencia a estudiantes intelectualmente sobresalientes.</span>
          </Stack>
          <Stack alignItems="center" sx={{ flex: '50%'}}>
            <Stack sx={{ fontWeight: 'bold', mb: 2 }} direction="row" spacing={1} alignItems="center">
              <Icon src={fortalecervinculos} />
              <span>Fortalecer Vinculos</span>
            </Stack>
            <span>Fortalecer los vínculos y el sentido de pertenencia entre los trabajadores, sus familias y las empresas que integran el CMN.</span>
          </Stack>
        </Stack> */}
      </Stack>
    </Stack>
  );
};

export default Objetivos;
